<template>
<div>
  <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true">添加</el-button>
  <el-dialog :visible="dialogVisible" title="新建项目" width="1000px" @close="closeDialog">
    <el-form :model="detail" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="区间值：" prop="sectionNum">
        <el-input v-model="detail.sectionNum" type="number"></el-input>
      </el-form-item>
      <el-form-item label="系数：" prop="coefficient">
        <el-input v-model="detail.coefficient" type="number"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'PledgeCreate',
  data() {
    return {
      dialogVisible: false,
      detail: {},
      rules: {
        sectionNum: {
          required: true,
          message: '请填写'
        },
        coefficient: {
          required: true,
          message: '请填写'
        }
      }
    };
  },

  methods: {
    ...mapActions('pledgeCoefficient', ['create']),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.create(this.detail).then(() => {
            this.$message({
              message: '添加成功！',
              type: 'success'
            });
            this.dialogVisible = false;
            this.$emit('refresh', {
              page: 1
            });
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
